import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../../02_molecules/Popup';
import PlusSvg from '../../../../public/static/icons/plus-circle.svg';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBProgramme extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openedItemIndex: -1,
    };

    this.onItemClick = this.onItemClick.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyPress, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress, false);
  }

  /**
   * Handle keyboard's key press.
   */
  onKeyPress(event) {
    const { openedItemIndex } = this.state;

    // Ignore key press when popup for this component is hidden.
    if (openedItemIndex === -1) {
      return;
    }

    if (event.keyCode === 27) {
      // Handle ESC key press.
      this.onPopupClose();
    }
  }

  onItemClick(index) {
    this.setState({ openedItemIndex: index });
  }

  onPopupClose() {
    this.setState({ openedItemIndex: -1 });
  }

  render() {
    const { title, description, items, behaviorSettings, uuid } = this.props;
    const { openedItemIndex } = this.state;

    const classes = [
      'bb',
      'bb-programme',
      styles['bb-programme'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <Popup
          isVisible={openedItemIndex >= 0}
          onPopupClose={this.onPopupClose}
          className={styles['popup-programme']}
        >
          {items.map((item, index) =>
            index !== openedItemIndex ? null : (
              <div className="inner" key={`popup-${item.title}`}>
                {item.title && <h2>{item.title}</h2>}

                {item.description && (
                  <FormattedText className="description" text={item.description} />
                )}
              </div>
            ),
          )}
        </Popup>

        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6 offset-lg-1 col-lg-6 content">
              {title && <h2 className="title rockitt">{title}</h2>}

              {description && <FormattedText className="description" text={description} />}
            </div>

            <div className="col-12 col-md-1 borders">
              <div className="element element-one" />
              <div className="element element-two" />
            </div>

            <div className="col-12 col-md-5 col-lg-4 items">
              {items.map((item, index) => (
                <div
                  className="label bb-programme--popup"
                  key={item.title}
                  onClick={() => this.onItemClick(index)}
                  onKeyPress={() => this.onItemClick(index)}
                >
                  <PlusSvg className="icon" />
                  {item.title}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BBProgramme.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

BBProgramme.defaultProps = {
  title: '',
  description: '',
  behaviorSettings: null,
  uuid: null,
};

export default BBProgramme;
